import 'react-notifications/lib/notifications.css'
import React, { Component } from 'react'
import { NotificationContainer, NotificationManager } from 'react-notifications'
import { useParams } from 'react-router-dom'
import { FaSave, FaArrowLeft } from "react-icons/fa"
import AdminLayout from "../../../../components/AdminLayout"

//Components
import CardService from "../../../../services/card_services"

export function withRouter(Children) {
    return (props) => {
        const match = { params: useParams() };
        return <Children {...props} match={match} />
    }
}

class AdminUpdateCollection extends Component {
    constructor(props) {
        super(props)
        this.state = {
            processing: false,
            success: false,
            collection_uuid: null,
            name: null,
            description_fr: null,
            description_en: null,
        }
    }

    componentDidMount = async() => {
        const { id } = this.props.match.params
        const collections = await CardService.getCollections()
        for(let collection of collections){
            if(collection.collection_uuid === id)
                this.setState({name: collection.collection_name, description_fr: collection.description.fr, description_en: collection.description.en || collection.description, collection_uuid: id})
        }
    }

    update = async () => {
        if (!this.state.name || !this.state.description_fr || !this.state.description_en)
            NotificationManager.error('Missing information')
        else {
            try {
                this.setState({processing: true})
                const data = await CardService.updateCollection(this.state.collection_uuid, this.state.name, {en: this.state.description_en, fr: this.state.description_fr})
                NotificationManager.success(data.message)
                this.setState({processing: false, success: true})
            } catch (e) {
                this.setState({processing: false})
                NotificationManager.error(e.response && e.response.data ? e.response.data.message : e.message)
            }
        }
    }

    render() {
        return (
            <>
                <AdminLayout 
                    title="Update Collection"
                    breadcrumbs={[
                        { label: 'Buds', href: '/admin/buds' },
                        { label: 'Update Collection' }
                    ]}
                >
                    <div className="max-w-3xl mx-auto space-y-6">
                        {/* Instructions */}
                        <div className="bg-purple-50 border border-purple-200 rounded-xl p-4">
                            <p className="text-purple-800 font-medium">Update the information for this collection</p>
                        </div>

                        {/* Form Card */}
                        <div className="bg-white rounded-xl shadow-md border border-gray-200 p-6 space-y-4">
                            <h3 className="text-lg font-bold text-gray-900">Collection Details</h3>

                            {/* Collection Name */}
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2">Collection Name *</label>
                                <input 
                                    type="text" 
                                    placeholder="Set Collection name" 
                                    onChange={(e) => this.setState({name: e.target.value})} 
                                    value={this.state.name || ''}
                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent outline-none"
                                />
                            </div>

                            {/* Description EN */}
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2">Description (English) *</label>
                                <textarea 
                                    placeholder="Description EN" 
                                    onChange={(e) => this.setState({description_en: e.target.value})} 
                                    value={this.state.description_en || ''}
                                    rows="4"
                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent outline-none resize-none"
                                ></textarea>
                            </div>

                            {/* Description FR */}
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2">Description (French) *</label>
                                <textarea 
                                    placeholder="Description FR" 
                                    onChange={(e) => this.setState({description_fr: e.target.value})} 
                                    value={this.state.description_fr || ''}
                                    rows="4"
                                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent outline-none resize-none"
                                ></textarea>
                            </div>
                        </div>

                        {/* Action Buttons */}
                        <div className="flex justify-end gap-3">
                            {this.state.processing ? (
                                <div className="px-6 py-3 bg-gray-100 text-gray-500 rounded-lg font-medium">
                                    Processing... Please wait
                                </div>
                            ) : this.state.success ? (
                                <button 
                                    onClick={() => window.location.href="/admin/buds"}
                                    className="px-6 py-3 bg-gradient-to-r from-gray-500 to-gray-600 text-white rounded-lg hover:from-gray-600 hover:to-gray-700 transition-all font-medium shadow-md hover:shadow-lg flex items-center gap-2"
                                >
                                    <FaArrowLeft />
                                    Back to Buds
                                </button>
                            ) : (
                                <button 
                                    onClick={this.update}
                                    className="px-6 py-3 bg-gradient-to-r from-purple-500 to-pink-500 text-white rounded-lg hover:from-purple-600 hover:to-pink-600 transition-all font-medium shadow-md hover:shadow-lg flex items-center gap-2"
                                >
                                    <FaSave />
                                    Update Collection
                                </button>
                            )}
                        </div>
                    </div>
                </AdminLayout>
                <NotificationContainer />
            </>
        )
    }
}

export default withRouter(AdminUpdateCollection)